import React from "react";
import { Button } from "./ui/button";
import { Zap, Flower2, Hand, Sparkles } from "lucide-react";

const FEATURE_BG = "https://static.prod-images.emergentagent.com/jobs/25f97584-112a-47b2-84d3-7d9ab16d2f41/images/a6b96e6774c874fe76a2273f9696af1e02f61edf83ce1cd0dce675922d613880.png";

const ICONS = { "Laser Hair Removal": Zap, Waxing: Flower2, Nails: Hand };

function cleanName(name) {
  return name.replace(/^(Laser )?Special:\s*/, "");
}

function SpecialCard({ svc, onBook, featured }) {
  const Icon = ICONS[svc.category] || Sparkles;
  return (
    <div
      data-testid={`special-card-${svc.id}`}
      className={`glass-card rounded-sm p-8 flex flex-col group ${featured ? "md:col-span-2 border-[#FF2079]/40" : ""}`}
    >
      <div className="flex items-center justify-between mb-6">
        <div className="w-11 h-11 rounded-sm bg-[#FF2079]/10 border border-[#FF2079]/30 flex items-center justify-center">
          <Icon className="w-5 h-5 text-[#FF2079]" />
        </div>
        <span className="eyebrow text-[#FF2079]">{svc.category} Special</span>
      </div>
      <h3 className={`font-display text-white mb-3 leading-snug ${featured ? "text-3xl md:text-4xl" : "text-2xl"}`}>
        {cleanName(svc.name)}
      </h3>
      <p className="text-sm text-[#A09CA3] leading-relaxed flex-1">{svc.description}</p>
      <div className="mt-6 flex items-end justify-between gap-4">
        <div>
          {svc.regular_price_label && (
            <div data-testid={`special-regular-${svc.id}`} className="text-sm text-[#A09CA3] line-through">
              {svc.regular_price_label}
            </div>
          )}
          <div data-testid={`special-price-${svc.id}`} className="font-display text-4xl text-[#FF2079]">
            {svc.price_label || `$${svc.price}`}
          </div>
        </div>
        <Button
          data-testid={`special-book-${svc.id}-btn`}
          onClick={() => onBook(svc)}
          className="pink-glow-btn bg-[#FF2079] hover:bg-[#D91666] text-white rounded-sm h-11 px-6 text-[10px] tracking-[0.28em] uppercase"
        >
          Book Deal
        </Button>
      </div>
    </div>
  );
}

export default function Promotions({ services = [], onBookService }) {
  const specials = services.filter((s) => s.is_special);
  const featuredId = specials.find((s) => s.category === "Laser Hair Removal")?.id;

  return (
    <section id="promotions" data-testid="promotions-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(${FEATURE_BG})` }} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <div className="eyebrow mb-4">Special Offers</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
            Deals worth
            <br />
            <span className="italic text-[#FF2079]">glowing about.</span>
          </h2>
          <p className="mt-6 text-[#A09CA3] text-base leading-relaxed max-w-xl">
            Laser packages, waxing bundles and nail combos — prior booking only.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {specials.map((svc) => (
            <SpecialCard key={svc.id} svc={svc} onBook={onBookService} featured={svc.id === featuredId} />
          ))}
        </div>

        <p data-testid="laser-terms" className="mt-10 text-xs text-[#A09CA3] leading-relaxed max-w-3xl">
          Laser offers: no refunds on laser services or packages. Service may be denied based on medical conditions and
          results vary by skin. A consultation may be required. Please tell us about any medications or skin conditions
          and avoid sun exposure and tanning before and after treatment.
        </p>
      </div>
    </section>
  );
}
